export default "__VITE_ASSET__dMf$7KvW__"